<template>
  <div class="custom-form cmi-res">
    <div class="panel-body">
      <div class="panel panel-info cmi-search-header-panel">
        <div class="row cmi-search-wrapper">
          <div class="col-md-10 col-md-offset-1">
            <div class="cmi-search-header">
              <div class="row cmi-search-header-row">
                <div class="col-md-4 header-left">
                  <span>Select address</span>
                </div>
                <div class="col-md-6 header-middle">
                  <select
                    id="res_FilterResLabel"
                    name="adr_FilterLabel"
                    @change="getFormDataByLabel"
                    v-model.trim="adr_FilterLabel"
                    class="form-control"
                  >
                    <option></option>
                    <option
                      v-for="item in addressLabels"
                      v-bind:value="item.value"
                      :key="item.value"
                      >{{ item.label }}</option
                    >
                  </select>
                </div>
                <div class="col-md-2 header-right">
                  <span
                    v-if="aniLabelsLoading"
                    class="fa fa-spinner fa-spin fa-3x fa-fw"
                  ></span>
                </div>
              </div>
              <div class="row cmi-search-header-row">
                <div class="col-md-6 col-md-offset-3 cmi-search-header-btn-add">
                  <button
                    @click="newFormData"
                    type="submit"
                    class="btn btn-primary"
                  >
                    Add new address
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Address</h3>
        </div>

        <div class="panel-body">
          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_Address1') }"
          >
            <label for="adr_Address1"
              >First line of address / House number</label
            >
            <input
              id="adr_Address1"
              name="adr_Address1"
              v-model.trim="fdata.adr_Address1"
              v-validate.initial="{ required: true, max: 50 }"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("adr_Address1") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_Address2') }"
          >
            <label for="adr_Address2">Street / Road</label>
            <input
              id="adr_Address2"
              name="adr_Address2"
              v-model.trim="fdata.adr_Address2"
              v-validate="{ max: 50 }"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("adr_Address2") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_Address3') }"
          >
            <label for="adr_Address3">Locality</label>
            <input
              id="adr_Address3"
              name="adr_Address3"
              v-model.trim="fdata.adr_Address3"
              v-validate="{ max: 50 }"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("adr_Address3") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_City') }"
          >
            <label for="adr_City">Town / City</label>
            <input
              id="adr_City"
              name="adr_City"
              v-model.trim="fdata.adr_City"
              v-validate.initial="{ required: true, max: 50 }"
              maxlength="50"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("adr_City") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_Postcode') }"
          >
            <label for="adr_Postcode">Postcode</label>
            <input
              id="adr_Postcode"
              name="adr_Postcode"
              v-model.trim="fdata.adr_Postcode"
              v-validate="{ max: 10, valid_uk_postcode: { active: true } }"
              maxlength="10"
              class="form-control"
            />
            <span class="help-block">{{ errors.first("adr_Postcode") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_Country') }"
          >
            <label for="adr_Country">Country</label>
            <select
              id="adr_Country"
              name="adr_Country"
              v-model="fdata.adr_Country"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Canada</option>
              <option value="2">USA</option>
              <option value="3">South Africa</option>
              <option value="4">Nigeria</option>
              <option value="97">Other</option>
            </select>
            <span class="help-block">{{ errors.first("adr_Country") }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_CountryText') }"
          >
            <label for="adr_CountryText">Specify Country name</label>
            <input
              id="adr_CountryText"
              name="adr_CountryText"
              v-model.trim="fdata.adr_CountryText"
              v-validate.initial="{
                required: !disableCriteriaMet_adr_CountryText,
                max: 100
              }"
              v-bind:disabled="disableCriteriaMet_adr_CountryText"
              maxlength="100"
              class="form-control"
            />
            <span class="help-block">{{
              errors.first("adr_CountryText")
            }}</span>
          </div>

          <div
            class="form-group"
            v-bind:class="{ 'has-error': errors.has('adr_Status') }"
          >
            <label for="adr_Status">Status</label>
            <select
              id="adr_Status"
              name="adr_Status"
              v-model="fdata.adr_Status"
              v-validate.initial="{ required: true }"
              class="form-control"
            >
              <option></option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
              <option value="90">Delete</option>
            </select>
            <span class="help-block">{{ errors.first("adr_Status") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <modal
        name="alert-dialog-address"
        :width="400"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>

      <div class="btn-submit-wrapper">
        <div v-if="showAnimation" class="cc-animation">
          <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
          <span>Form submission in progress</span>
        </div>
        <div class="cc-submit-btn-wrapper">
          <button
            v-on:click="updateAddress"
            v-bind:disabled="showAnimation"
            type="submit"
            class="btn btn-primary"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VueRecaptcha from "vue-recaptcha";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  // components: {
  //   VueRecaptcha,
  // },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      fdata: {
        pkey: 0,
        adr_Address1: "",
        adr_Address2: "",
        adr_Address3: "",
        adr_City: "",
        adr_Postcode: "",
        adr_Country: null,
        adr_CountryText: "",
        adr_Branch: null,
        adr_Status: null
      },
      showAnimation: false,
      subformIndex: 0,
      alertMessage: "",
      adr_FilterLabel: "",
      addressLabels: [],
      aniLabelsLoading: false
    };
  },
  watch: {
    disableCriteriaMet_adr_CountryText: function(newValue) {
      if (newValue == false) this.fdata.adr_CountryText = "";
    }
  },
  methods: {
    ...mapActions(["getToken"]),
    updateAddress: async function() {
      let actionUrl = `${this.baseUrl}UpdateFormData`;
      const valStatus = await this.$validator.validateAll();
      if (!valStatus) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-address");
        return;
      }

      this.showAnimation = true;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata, config));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }

      if (rData != 0) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-address");
        return;
      }
      if (!this.fdata.pkey) {
        this.resetFormData();
      }
      this.alertMessage = "Your form has been submitted successfully";
      this.$modal.show("alert-dialog-address");
      this.getAddressLabels();
      this.showAnimation = false;
    },
    getFormDataByLabel: async function() {
      if (!this.adr_FilterLabel) {
        this.resetFormData();
        return;
      }
      this.aniLabelsLoading = true;
      let actionUrl = `${this.baseUrl}GetFormDataByLabel`;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { pkey: this.adr_FilterLabel }
      };
      let rData = null;
      ({ data: rData } = await axios.get(actionUrl, config));
      if (rData) {
        Object.assign(this.fdata, rData);
      }
      this.aniLabelsLoading = false;
    },
    getAddressLabels: async function() {
      this.aniLabelsLoading = true;

      let actionUrl = `${this.baseUrl}GetAddressLabels`;
      const token = await this.getToken({ vm: this });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
      let rData = null;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }

      if (rData) {
        Object.assign(this.addressLabels, rData);
      }
      this.aniLabelsLoading = false;
    },
    newFormData: function() {
      this.resetFormData();
      this.adr_FilterLabel = "";
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        pkey: 0,
        adr_Address1: "",
        adr_Address2: "",
        adr_Address3: "",
        adr_City: "",
        adr_Postcode: "",
        adr_Country: null,
        adr_CountryText: "",
        adr_Branch: null,
        adr_Status: null
      });
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-address");
    }
  },
  computed: {
    disableCriteriaMet_adr_CountryText: function() {
      if (
        this.fdata.adr_Country != null &&
        [97].indexOf(this.fdata.adr_Country) != -1
      ) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.getAddressLabels();
  }
};
</script>
